import { Box, Circle, Flex, useRadio } from "@chakra-ui/react";
import { UseRadioProps } from "@chakra-ui/react";

interface RadioProps extends UseRadioProps {
  children: React.ReactNode;
  elementWidth?: string;
  isDisabled?: boolean;
}

export function Radio(props: RadioProps) {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label" flex={1} minWidth={props.elementWidth}>
      <input {...input} />
      <Flex
        {...checkbox}
        cursor="pointer"
        bg="white"
        width="full"
        borderColor="white"
        borderWidth="1px"
        borderRadius="5px"
        fontSize="0.9rem"
        color="#00090"
        direction="row"
        align="center"
        boxShadow="card"
        _checked={{
          bg: "#D7DEF8",
          borderColor: "#7147BD",
        }}
        p="2.5">
        <Circle
          {...checkbox}
          size="20px"
          bg="white"
          mr="5px"
          borderColor="#E2E8F0"
          borderWidth="2px"
          _checked={{
            borderWidth: "6px",
            borderColor: "#3182CE",
          }}
        />
        {props.children}
      </Flex>
    </Box>
  );
}
